import {
    Icon, Tooltip,
} from '@shopify/polaris';  
//import {AttributeRecommendations} from '../global/AttributeRecommendations';
//import '../global/configurables.scss';
import App from '../../App';
import {
    PositionBasedModelMinor,
  } from '@shopify/polaris-icons';

function AttributeRecommendations(props) {
    //console.log('Attr Props');
    //console.log(JSON.stringify(props));
    //const plans = props.plans;
    //const boxHeight = props.boxHeight
    //const planUrl = props.planUrl;
    //const storeUrl = props.StoreUrl;

    return (
        <span className={'attribute-recommendation dyna-test'}>
            {
            (!props.configurables.hasOwnProperty('suggestions'))?
            ''
            :
            (props.configurables.suggestions && props.configurables.suggestions[props.suggestionKey])?
            <Tooltip content={props.tooltip}><span><Icon source={PositionBasedModelMinor} color="base" /> <small>{props.configurables.suggestions[props.suggestionKey]}</small></span></Tooltip>
            :
            ''
            }
        </span>
    );
}


export default AttributeRecommendations;
